import { clientId } from "../init";

const endpoints = {
  ws: window.ini.WEBSOCKET_URL,
  ws_path: window.ini.WEBSOCKET_PATH,
  configApiUrl: `${window.ini.CONFIG_API_URL}/config-api/landing-pages/list?tenantId=${clientId}`,
};

export default endpoints;